import React from 'react'
import styled from 'react-emotion'
import { StyledFormElement as FormElement } from './FormElement'
import { Icon } from 'common/components/Icon'

export const Loader = styled(({ square, t, ...props }) => (
  <FormElement {...props}>
    <Icon icon={square ? 'loader-square' : 'loader'} />
  </FormElement>
))(({ extraLarge }) => ({
  border: 'none',
  '.icon-loader': extraLarge && {
    width: 12,
    height: 12,
    borderRadius: 6,
    borderWidth: 3
  }
}))

export default Loader
